<template>
    <div class="wrap-content">
        <div class="data-import small-card">
            <div class="row">
                <div
                    v-for="(data, index) in importDataHeader"
                    :key="index"
                    class="col-md-3"
                    :class="index == tabData ? 'active' : ''"
                    @click="tabFilter(index)"
                >
                    <card-data
                        :logo="data.logo"
                        :name="data.name"
                        :description="data.description"
                    ></card-data>
                </div>
            </div>
        </div>

        <!-- Dow Jones listing -->
        <div v-if="tabData == 0">
            <div ref="listingArea" class="config-list">
                <div v-show="listVal <= 850" class="config-list-dropdown">
                    <b-form-group
                        id="input-group-5"
                        label="Screening Data"
                        label-for="screening-data"
                    >
                        <b-form-select
                            id="screening-data"
                            v-model="menuListingChanges"
                            class="form-control"
                            :options="menuListing"
                            @change="onChange(menuListingChanges)"
                        >
                        </b-form-select>
                    </b-form-group>
                </div>
                <ul v-show="listVal >= 850 && listVal <= 1500">
                    <li
                        v-for="(list, index) in menuListing.slice(0, 8)"
                        :key="index"
                    >
                        <router-link
                            :to="list.value"
                            :class="{ 'pointer-none': showPageLoader }"
                        >
                            <span>{{ list.text }}</span>
                        </router-link>
                    </li>
                    <li
                        class="open-dropdown"
                        :class="[
                            $route.meta.responsiveMenuItem == true
                                ? 'router-link-exact-active'
                                : '' || listDropdown == true
                                ? 'router-link-exact-active'
                                : '',
                        ]"
                    >
                        <a
                            href="javascript:void(0);"
                            @click="listDropdown ^= true"
                        >
                            <i class="icon-dropdown-icon"></i>
                        </a>

                        <div
                            v-if="listDropdown"
                            v-on-click-outside="close"
                            class="dropdown-open"
                        >
                            <ul>
                                <li
                                    v-for="(listo, index) in menuListing.slice(
                                        8,
                                        menuListing.length
                                    )"
                                    :key="index"
                                    @click="listDropdown ^= true"
                                >
                                    <router-link
                                        :to="listo.value"
                                        :class="{
                                            'pointer-none': showPageLoader,
                                        }"
                                    >
                                        <span>{{ listo.text }}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
                <ul v-show="listVal >= 1499">
                    <li v-for="(list, index) in menuListing" :key="index">
                        <router-link
                            :to="list.value"
                            :class="{ 'pointer-none': showPageLoader }"
                        >
                            <span>{{ list.text }}</span>
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="config-card-block">
                <router-view @item-length="tableItemLength" />
            </div>
        </div>

        <!-- world check listing -->
        <div v-if="tabData == 1">
            <div ref="listingArea" class="config-list">
                <div v-show="listVal <= 850" class="config-list-dropdown">
                    <b-form-group
                        id="input-group-5"
                        label="Screening Data"
                        label-for="screening-data"
                    >
                        <b-form-select
                            id="screening-data"
                            v-model="worldCallmenuListingChanges"
                            class="form-control"
                            :options="worldCallMenuListing"
                            @change="onChange(worldCallmenuListingChanges)"
                        >
                        </b-form-select>
                    </b-form-group>
                </div>
                <ul v-show="listVal >= 850 && listVal <= 1500">
                    <li
                        v-for="(list, index) in worldCallMenuListing"
                        :key="index"
                    >
                        <router-link
                            :to="list.value"
                            :class="{ 'pointer-none': showPageLoader }"
                        >
                            <span>{{ list.text }}</span>
                        </router-link>
                    </li>
                </ul>
                <ul v-show="listVal >= 1499">
                    <li
                        v-for="(list, index) in worldCallMenuListing"
                        :key="index"
                    >
                        <router-link
                            :to="list.value"
                            :class="{ 'pointer-none': showPageLoader }"
                        >
                            <span>{{ list.text }}</span>
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="config-card-block">
                <router-view @item-length="tableItemLength" />
            </div>
        </div>

        <!-- Black list -->
        <div v-if="tabData == 2 || tabData == 3 || tabData == 4">
            <router-view />
        </div>
    </div>
</template>

<script>
import cardData from '@/components/CardData.vue'
// import uploadFile from '@/components/UploadFile.vue'
import { directive as onClickOutside } from 'vue-on-click-outside'
import { mapGetters } from 'vuex'
export default {
    components: {
        cardData,
        // uploadFile,
    },

    directives: {
        onClickOutside: onClickOutside,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            tabData: 0,
            listData: null,
            tableItemData: null,
            listVal: null,
            listDropdown: false,
            menuListingChanges: '/configuration/screening-data/gender',
            menuListing: [
                {
                    value: '/configuration/screening-data/gender',
                    text: 'Gender',
                },
                {
                    value: '/configuration/screening-data/deceased',
                    text: 'Deceased',
                },
                {
                    value: '/configuration/screening-data/record-status',
                    text: 'Record Status',
                },
                {
                    value: '/configuration/screening-data/name-type',
                    text: 'Name Type',
                },
                {
                    value: '/configuration/screening-data/descprition-1',
                    text: 'Description 1',
                },
                {
                    value: '/configuration/screening-data/descprition-2',
                    text: 'Description 2',
                },
                {
                    value: '/configuration/screening-data/descprition-3',
                    text: 'Description 3',
                },
                {
                    value: '/configuration/screening-data/role-type',
                    text: 'Role Type',
                },
                {
                    value: '/configuration/screening-data/occupation',
                    text: 'Occupation',
                },
                {
                    value: '/configuration/screening-data/date-type',
                    text: 'Date Type',
                },
                {
                    value: '/configuration/screening-data/sanction-reference',
                    text: 'Sanctions Reference',
                },
                {
                    value: '/configuration/screening-data/country',
                    text: 'Country',
                },
                {
                    value: '/configuration/screening-data/country-type',
                    text: 'Country Type',
                },
                {
                    value: '/configuration/screening-data/identification',
                    text: 'Identification Type',
                },
                {
                    value: '/configuration/screening-data/relationship-type',
                    text: 'Relationship Type',
                },
            ],

            worldCallmenuListingChanges:
                '/configuration/screening-data/world-check',
            worldCallMenuListing: [
                {
                    value: '/configuration/screening-data/world-check',
                    text: 'Category',
                },
                {
                    value: '/configuration/screening-data/world-check/sub-category',
                    text: 'Sub-Category',
                },
                {
                    value: '/configuration/screening-data/world-check/deceased',
                    text: 'Deceased',
                },
                {
                    value: '/configuration/screening-data/world-check/location',
                    text: 'Locations',
                },
                {
                    value: '/configuration/screening-data/world-check/EIType',
                    text: 'E/I',
                },
                {
                    value: '/configuration/screening-data/world-check/keyword',
                    text: 'Keyword',
                },
                {
                    value: '/configuration/screening-data/world-check/update-category',
                    text: 'Update Category',
                },
                {
                    value: '/configuration/screening-data/world-check/pep-status',
                    text: 'PEP Status',
                },
            ],
            importDataHeader: [
                {
                    logo: 'logo1.png',
                    name: 'DOW JONES',
                    description: 'Manage Dow Jones Data',
                    active: true,
                },
                {
                    logo: 'logo2.png',
                    name: 'WORLD-CHECK',
                    description: 'Manage World Check Data',
                },
                {
                    logo: 'logo3.png',
                    name: 'BLACK LIST',
                    description: "Manage Client's Blacklist Data",
                },
                {
                    logo: 'logo3.png',
                    name: 'IDENFO LIST',
                    description: "Manage Idenfo's Blacklist Data",
                },
                {
                    logo: 'logo3.png',
                    name: 'Configuration | Delta List',
                    description: 'Manage Delta List Data',
                    active: false,
                    link: 'delta-list',
                    // permission: ['upload-delta-list'],
                },
            ],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['showPageLoader']),
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.listWidthVal()
        this.onLoad()
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */

    methods: {
        listWidthVal() {
            this.listVal = this.$refs.listingArea.offsetWidth
        },
        tableItemLength(val) {
            this.tableItemData = val
        },
        close() {
            this.listDropdown = false
        },
        tabFilter(index) {
            this.tabData = index
            if (this.tabData == 0) {
                this.$router.push('/configuration/screening-data/gender')
            } else if (this.tabData == 1) {
                this.$router.push('/configuration/screening-data/world-check')
            } else if (this.tabData == 2) {
                this.$router.push('/configuration/screening-data/black-list')
            } else if (this.tabData == 3) {
                console.log(this.tabData)
                this.$router.push('/configuration/screening-data/idenfo-list')
            } else if (this.tabData == 4) {
                console.log(this.tabData)
                this.$router.push('/configuration/screening-data/delta-list')
            }
        },
        onChange(val) {
            this.$router.push('' + val + '')
        },
        onLoad() {
            this.tabData = this.$route.meta.selectedTab
        },
    }, // End of Component > methods
} // End of export default
</script>
